import React from "react";
import { Main } from "./Main";
import { icons } from "@kernel/icon-set-essentials";
import { IconContextProvider } from "@kernel/react-icons";
import {
  GlobalDialogBlocProvider,
  MainBlocProvider,
  ToolboxBlocProvider
} from "@modules";
import { DialogsContainer } from "../layout/DialogContainer";

function App() {
  return (
    <IconContextProvider icons={icons}>
      <MainBlocProvider>
        <GlobalDialogBlocProvider>
          <ToolboxBlocProvider>
            <DialogsContainer />
            <Main />
          </ToolboxBlocProvider>
        </GlobalDialogBlocProvider>
      </MainBlocProvider>
    </IconContextProvider>
  );
}

export default App;
